import { ReduxAction } from './helper';

export const setContextContent = new ReduxAction("CONTEXT_CONTENT_SET", 
    (content, actions) => { return { content, contextActions: actions }; });
export const clearContextContent = new ReduxAction("CONTEXT_CONTENT_CLEAR");